import React from 'react';

import {colors} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ConnectedForms from './icon-connected-forms.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return (
        <ConnectedForms
            {...validProps}
            fill={validProps.fill || validProps.color || colors.black}
        />
    );
}
SvgComponent.iconName = 'formMapping';

/**
 * @deprecated This is a legacy icon
 */
export const ConnectedFormsIcon = svgIconWrapper(SvgComponent);
